/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import COUNTRIES_SELECT_OPTIONS from "constants/countries";
import { ISO_COUNTRIES } from "constants/countries";

export interface SelectOption {
  label: string;
  value: string;
}

export const SELECT_FIELD_OPTIONS: Record<string, SelectOption[]> = {
  // Country options
  nationality: COUNTRIES_SELECT_OPTIONS,
  
  // ID Type options
  id_type: [
    { label: "Passport", value: "3" }
  ],
  
  // Passport Type options
  document_type: [
    { label: "Normal", value: "Normal" },
    { label: "Royal / Private", value: "Royal / Private" },
    { label: "Diplomatic", value: "Diplomatic" },
    { label: "Mission Passport", value: "Mission Passport" },
    { label: "Travel Document", value: "Travel Document" },
    { label: "Formal / Service", value: "Formal / Service" },
    { label: "Official Passport", value: "Official Passport" }
  ],
  
  // Issuing Authority options (same as countries)
  document_issuing_authority: ISO_COUNTRIES,
  
  // Gender options
  gender: [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" },
    { label: "Prefer not to say", value: "prefer_not_to_say" }
  ],
  
  // Title/Prefix options
  titles: [
    { label: "Mr.", value: "mr" },
    { label: "Mrs.", value: "mrs" },
    { label: "Ms.", value: "ms" },
    { label: "Dr.", value: "dr" },
    { label: "Prof.", value: "prof" }
  ],
  
  // Blood type options
  blood_types: [
    { label: "A+", value: "a_positive" },
    { label: "A-", value: "a_negative" },
    { label: "B+", value: "b_positive" },
    { label: "B-", value: "b_negative" },
    { label: "AB+", value: "ab_positive" },
    { label: "AB-", value: "ab_negative" },
    { label: "O+", value: "o_positive" },
    { label: "O-", value: "o_negative" },
    { label: "Unknown", value: "unknown" }
  ],
  
  // Yes/No options
  yes_no: [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" }
  ],
  
  // True/False options
  true_false: [
    { label: "True", value: "true" },
    { label: "False", value: "false" }
  ]
};

/**
 * Get select field options by key
 */
export const getSelectFieldOptions = (optionsKey: string): SelectOption[] => {
  return SELECT_FIELD_OPTIONS[optionsKey] || [];
};
